import { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { withStyles } from '@aura/components/styles'
import Grid from '@aura/components/grid'
import Box from '@aura/components/box'
import Typography from '@aura/components/typography'
import Button from '@aura/components/button'
import SmsIcon from '@mui/icons-material/Sms'
import CallIcon from '@mui/icons-material/Call'
import Radio from '@aura/components/radio'
import { useCookies } from 'react-cookie'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import Languages from '../../../../constants/languages'
import CustomLoader from '../../../../components/custom-loader'
import AccountRecoveryTypes from '../../../../constants/factor-types'
import FetchAccountRecoveryStatus from '../../../../constants/fetch-account-recovery'
import RegistrationContainerNew from '../../../../components/registration-container-new'
import { LOGIN_ROUTE } from '../../../../constants/routes'
import { formatPhoneNumber } from '../../../../utils/formatNumber'
import { cookieNameLoginAppCookie } from '../../../../constants/app'
import { showLoader, hideLoader } from '../../../../utils/loader-actions'
import styles from './styles'


const Component = ({
    classes,
    userData,
    getAccountRecovery,
    accountRecoveryData,
    accountRecoveryStatus,
    onSelectType,
}) => {
    const { i18n, t: translate } = useTranslation()
    const history = useHistory()
    const [ hoveredType, setHoveredType ] = useState(null)
    const [ selectedLanguage, setSelectedLanguage ] = useState(i18n.language)
    const [ selectedValue, setSelectedValue ] = useState('sms')
    const [ cookies ] = useCookies([ cookieNameLoginAppCookie ])
    const redirectTo = cookies[cookieNameLoginAppCookie]
    const title = translate('verificationMethod')
    const verbiage = <Typography>{translate('registrationFlow.recoveryTitle')}</Typography>

    useEffect(() => {
        hideLoader()
    }, [ ])
    useEffect(() => {
        if (getAccountRecovery && (userData && userData.userId)) {
            getAccountRecovery({ oktaUserId: userData.userId })
        }
    }, [ userData ])

    useEffect(() => {
        if (accountRecoveryData && accountRecoveryData.length > 0) {
            setSelectedValue(accountRecoveryData[0].type)
        }
    }, [ accountRecoveryData ])

    useEffect(() => {
        setSelectedLanguage(i18n.language)
    }, [ i18n.language ])

    const handleSelect = useCallback(type => {
        if (onSelectType) {
            showLoader()
            onSelectType(type)
        }
    }, [ onSelectType ])

    const handleChange = event => {
        setSelectedValue(event.target.value)
    }

    const handleCancel = useCallback(() => {
        if (redirectTo) {
            window.location.href = `/${redirectTo}/login`
        } else {
            showLoader()
            history.push(LOGIN_ROUTE)
        }
    })

    const footerContent = (<Grid className={classes.buttonContainer} container item md={12} xs={12}>
        <Grid container className={classes.actionRow} justify="flex-end">
            <Button
                className={classes.buttonSubmit}
                onClick={() => handleSelect(selectedValue)}
                variant="contained"
                disabled={!selectedValue}
                disableElevation={!selectedValue}
                style={!selectedValue ? { cursor: 'not-allowed', opacity: 0.5 } : {}}
            >
                {translate('next')}
            </Button>
        </Grid>
    </Grid>)

    return (
        <RegistrationContainerNew footerActions={footerContent} title={title} verbiage={verbiage}>
            <Grid className={classes.recoveryContainer}>
                {accountRecoveryStatus === FetchAccountRecoveryStatus.PENDING
                    ? <CustomLoader
                        label={translate('loading')}
                        style={{ marginLeft: '38%', marginTop: '40px' }}
                    />
                    : <Box className={classes.accountRecoveryOptions}>
                        {Array.isArray(accountRecoveryData) && accountRecoveryData.map((item, idx) => (
                            <Box
                                key={idx}
                                className={`${classes.accountRecoveryOption} 
                                    ${(hoveredType === item.type || selectedValue === item.type) && classes.accountRecoveryOptionSelected} 
                                    ${selectedLanguage === Languages.FRENCH && classes.accountRecoveryOptionFr}`
                                }
                                onMouseEnter={() => setHoveredType(item.type)}
                                onMouseLeave={() => setHoveredType(null)}
                                onClick={() => handleChange({ target: { value: item.type } })}
                            >
                                <Box className={classes.accountRecoveryBox}>{item.type === AccountRecoveryTypes.SMS
                                    ? <SmsIcon className={`${classes.accountRecoveryIcon} ${hoveredType === item.type && classes.accountRecoveryIconSelected}`} />
                                    : item.type === AccountRecoveryTypes.CALL
                                        ? <CallIcon className={`${classes.accountRecoveryIcon} ${hoveredType === item.type && classes.accountRecoveryIconSelected}`} />
                                        : null
                                }
                                <Typography className={`${classes.accountRecoveryType} ${hoveredType === item.type && classes.accountRecoveryTypeSelected}`}>{translate(item.type)}</Typography>
                                <Typography className={`${classes.accountRecoveryPhoneNumber} ${hoveredType === item.type && classes.accountRecoveryPhoneNumberSelected}`}>{formatPhoneNumber(item)}</Typography></Box>
                                <Box className={classes.radioButton}>
                                    <Radio
                                        checked={selectedValue === item.type}
                                        className={classes.radio}
                                        onChange={handleChange}
                                        value={item.type}
                                        name="radio-buttons"
                                        inputProps={{ 'aria-label': item.type }}
                                    />

                                </Box>
                            </Box>
                        ))}
                    </Box>}
                <Box component="p" className={classes.warningLine}>{translate('errorPage.helpText')} </Box>
            </Grid>
        </RegistrationContainerNew>
    )
}

Component.displayName = 'RecoverySelection'

Component.propTypes = {
    accountRecoveryData: PropTypes.array,
    classes: PropTypes.shape({
        button: PropTypes.object,
        buttonContainer: PropTypes.object
    }),
    onNext: PropTypes.func.isRequired,
    onSelectType: PropTypes.func
}

export default withStyles(Component, styles)
